import React from "react";

export default function Intro(){
    return <div style={{ height: '90%', width: '90%', overflow: 'scroll' }}>
        Select ads to personalize for prospecting and closing sales 1-2-3!
    </div>
}